import React, { useState } from "react";
import { Alignment, Button, Navbar, NavbarGroup, NavbarHeading, Tabs } from "@blueprintjs/core";

import AvanadeLogo from "./AvanadeLogo";
import SettingsDrawer from "./SettingsDrawer";
import "./ConsoleNavbar.scss";
import { Link, Outlet } from "react-router-dom";
import CustomNavLink from "routes/CustomNavLink";

export default function ConsoleNavbar() {
    const [open, setOpen] = useState(false);
    return (
        <div className="navbar-container">
            <Navbar className={"bp3-navbar"} fixedToTop>
                <NavbarGroup align={Alignment.LEFT} className="left-group">
                    <Link to="/">
                        <NavbarHeading>
                            <AvanadeLogo />
                        </NavbarHeading>
                    </Link>
                    <div id="tab-group">
                        <Tabs id="navbar-tabs">
                            <CustomNavLink page="project" view="runs">
                                Project
                            </CustomNavLink>
                            <CustomNavLink page="policies">Policy</CustomNavLink>
                            <CustomNavLink page="diagnostics">Diagnostic</CustomNavLink>
                        </Tabs>
                    </div>
                </NavbarGroup>
                <NavbarGroup align={Alignment.RIGHT} className="right-group">
                    {/* <Button minimal icon="user" /> */}
                    <Button minimal icon="settings" onClick={() => setOpen(!open)} />
                </NavbarGroup>
            </Navbar>
            <SettingsDrawer open={open} setOpen={setOpen} />
            <Outlet />
        </div>
    );
}
